import '../../assets/entity-list.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ListCourseDto } from '../../general/dtos';
import { useProducts } from '../../providers/products-provider';
import { Link, useLocation } from 'react-router-dom';

export function ProductList({ onCourseSelected }: { onCourseSelected?: () => void }) {
    const { courses, selectedCourse, setSelectedCourse, loading, error } = useProducts();
    const location = useLocation();
    const productTitle = (course: ListCourseDto) => {
        const params = new URLSearchParams(location.search);
        params.set('course', course.course_key);
        return <Link to={`${location.pathname}?${params.toString()}${location.hash}`}
            className="product-title-link"
            onClick={event => {
                event.stopPropagation();
                if (event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
                    onCourseSelected?.();
                }
            }}>{course.name}</Link>;
    };
    return (
        <div className="entity-list-container">
            {error && <div className="p-3" role="alert">{error}</div>}
            <div className="entity-list-wrapper">
                <DataTable
                    value={courses}
                    dataKey="course_key"
                    loading={loading}
                    selectionMode="single"
                    selection={selectedCourse}
                    onSelectionChange={e => {
                        const course = e.value as ListCourseDto | null;
                        if (course) {
                            setSelectedCourse(course);
                            onCourseSelected?.();
                        }
                    }}
                    onRowClick={event => {
                        const course = event.data as ListCourseDto;
                        if (course.course_key === selectedCourse?.course_key) onCourseSelected?.();
                    }}
                    scrollable
                    scrollHeight="flex"
                    filterDisplay="menu"
                    removableSort
                    emptyMessage={error ? 'Products are currently unavailable.' : 'There are no unassigned products available.'}
                >
                    <Column field="name" header="Product" body={productTitle} sortable filter />
                </DataTable>
            </div>
        </div>
    );
}
